import {IComponentController, IComponentOptions} from "angular";
import {UserAccessRole} from "../../model/UserAccessRole";
import {AccessLevelConfig} from "../../model/AccessLevelConfig";

interface AccessRole {
    name: string;
    title: string
}

export class AccessLevelPickerComponent implements IComponentController {

    private onAccessLevelChange: (value: string) => void;
    private accessLevelConfig: AccessLevelConfig;

    static instance: IComponentOptions = {
        template: require('./access-level-picker.component.html'),
        controller: [AccessLevelPickerComponent],
        bindings: {
            selectedAccessLevel: '=',
            onAccessLevelChange: '<',
            accessLevelConfig: '<'
        }
    };

    $onInit() {
        this.accessLevelConfig = this.accessLevelConfig || {
            disabled: false
        }
    }


    private allAccessLevels: AccessRole[] = [
        {name: UserAccessRole.BRAND, title: 'Brand'},
        {name: UserAccessRole.BRANCH, title: 'Branch'},
        {name: UserAccessRole.CORPORATE, title: 'Corporate'},
        {name: UserAccessRole.INDIVIDUAL, title: 'Individual'}
    ];
}